import React from 'react'
import { withAuthenticator } from '@aws-amplify/ui-react'
import { Link } from 'react-router-dom'

import { CurrentUserContext } from '../../libraries/auth'
import UserAvatar from '../containers/users/Avatar'
import DeleteAccount from '../containers/users/DeleteAccount'
import Dropdown from '../components/form/Dropdown'
import SettingsIcon from '../../assets/icons/settings.svg?react'
import Button from '../components/form/Button'
import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'
import { JobOffersExplorer } from '../containers/job-offers'
import ProfileLanguagesSection from '../containers/users/ProfileLanguagesSection'
import UserCvSection from '../containers/users/UserCvSection'
import UserAcademicTranscriptSection from '../containers/users/UserAcademicTranscriptSection'
import Card from '../components/layout/Card'
import { OuterTabGroup } from '../components/form/tab-groups'
import BookmarkedContent from '../containers/users/BookmarkedContent'
import VideosGrid from '../containers/content/videos/Grid'
import { useHistory } from '../../hocs/content/useVideos'

const UserProfilePage = () => {
  const { t } = useI18N()
  const { currentUser } = React.useContext(CurrentUserContext)
  const [showDeleteAccount, setShowDeleteAccount] = React.useState(false)
  const [activeTab, setActiveTab] = React.useState('profile')

  const settingsItems = [{ id: 'editProfile', item: <Link to='/onboarding/personal'><Button size='sm' variant='flat'>{t('user.edit.profile')}</Button></Link>}]
  if(currentUser?.stripeCustomerId) {
    settingsItems.push({ id: 'billing', item: <Link to='/profile/billing'><Button size='sm' variant='flat'>{t('user.manage.billing')}</Button></Link>})
  }
  settingsItems.push({ id: 'deleteAccount', item: <Button size='sm' variant='flat' onClick={() => setShowDeleteAccount(true)}>{t('user.close.account')}</Button>})

  const ProfileTabContent = (
    <>
      <div className='mt-4 md:flex items-start w-full gap-x-8'>
        <div className='w-full xs:w-1/2 lg:w-1/3'>
          <h3>{t('profile.documents.title')}</h3>
          <UserCvSection />
          <UserAcademicTranscriptSection />
        </div>
        <div className='w-full xs:w-1/2 lg:w-1/3'>
          <h3>{t('profile.languages.title')}</h3>
          <Card className='bg-white shadow-sm w-full mt-2'>
            <ProfileLanguagesSection />
          </Card>
        </div>
      </div>

      <h3 className='mt-6'>{t('jobs.see.applied')}</h3>
      <JobOffersExplorer defaultFilters={{ myJobOffers: true, hideFilterMyJobOffers: true, hideFilterIsInternal: true }} />
    </>
  )

  const HistoryTabContent = (
    <VideosGrid queryFn={() => useHistory()} />
  )

  return (
    <div>
      <div className='flex items-center gap-x-6 mb-6'>
        <UserAvatar size='xl' />
        <div className='w-full'>
          <div className='flex items-center justify-between gap-x-3'>
              <div className='flex items-center gap-x-4'>
                <PageHeading noMargin showGoBack={false}>
                  {currentUser?.name}
                </PageHeading>
                <Dropdown items={settingsItems} containerClass='content' noOrigin>
                  <Button size='sm' variant='flat' aria-label={t('menu.my.profile')} className='mt-1'>
                    <SettingsIcon width={24} height={24} className='stroke-electric-green rotate-90' />
                  </Button>
                </Dropdown>
              </div>
          </div>
        </div>
      </div>
      {showDeleteAccount && <DeleteAccount handleCancel={() => setShowDeleteAccount(false)} />}

      <OuterTabGroup
        tabs={[
          { id: 'profile', title: t('menu.my.profile') },
          { id: 'bookmarks', title: t('menu.bookmarks') },
          { id: 'history', title: t('videos.history') },
        ]}
        handleClick={setActiveTab}
        active={activeTab}
      />

      {activeTab === 'profile' && ProfileTabContent}
      {activeTab === 'bookmarks' && <BookmarkedContent />}
      {activeTab === 'history' && HistoryTabContent}
    </div>
  )
}

export default withAuthenticator(UserProfilePage)
